export var updateSortLabel = function(dataSelected) {
	$("#orderBy-select").find("h3").each(function() {
		$(this).removeClass("selected-sort");
		$(this).find(".fa-check").remove();
		if ($(this).data("value") == $("#orderBy").val()){
			if($("#orderBy").val() == "1"){
				var sesPz = sessionStorage.getItem("sesPz" + window.superCat);
				if($(this).hasClass("just-for-you-sort") && sesPz && sesPz != ""){
					$(this).addClass("selected-sort");
				}
				if(!$(this).hasClass("just-for-you-sort") && (!sesPz || sesPz == "")){
					$(this).addClass("selected-sort");
				}
			}else{
				$(this).addClass("selected-sort");
			}
		}
	});
	if ($(".selected-sort").length == 1) {
		$(".selected-sort").append('<i class="fa fa-check fa-lg pull-right"></i>');
	}
};
